import { compensationApiBaseUrl } from '../../shared/env';
import { createJsonClient } from '../../shared/httpClient';
import type { CatalogGateway } from './CatalogGateway';
import type { CompanyCatalogPage, CompanyCatalogQuery } from './types';
import { buildQuery, mapCompanyCatalogPage } from './wireMapping';

export class HttpCatalogGateway implements CatalogGateway {
  private readonly request = createJsonClient(compensationApiBaseUrl);

  async listItems(query: CompanyCatalogQuery = {}, signal?: AbortSignal): Promise<CompanyCatalogPage> {
    const qs = buildQuery({
      type: query.type, search: query.search, category: query.category, status: query.status, page: query.page, pageSize: query.pageSize,
    });
    return mapCompanyCatalogPage(await this.request<unknown>(`/api/benefit-deduction-catalog${qs}`, undefined, signal));
  }
}
